import React, { useEffect, useState } from 'react'
import Footer from '../Footer/Footer'
import { Outlet } from 'react-router-dom'
import Header from '../Header/Header'
import Preloader from '../Preloader/Preloader'
import { useLanguage } from '../../contexts/LanguageContext'

const headerData = {
  "logo": "/images/logo.svg"
}

// Footer data will be created dynamically with translations

const Layout = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useLanguage();

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1200);
  }, []);

  // Create footer data with translations
  const footerData = {
    "logo": "/images/logo.svg",
    "bgImg": "/images/footer-bg.png",
    "subTitle": t('footer.subTitle'),
  };


  return (
    <>
      {
        isLoading ? <Preloader /> : (
          <>
            <Header data={headerData}/>
            <Outlet />
            <Footer data={footerData}/>
          </>
        )
      }
    </>
  )
}

export default Layout;
